import { createContext, useState, useEffect } from "react";
import * as auth from "../Auth/auth";

const AuthContext = createContext();

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [jwt, setJwt] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [service, setService] = useState(null);
  const [adminMode, setAdminMode] = useState(false);

  useEffect(() => {
    getCurrentUser()
      .then(() => setIsLoading(false))
      .catch(() => setIsLoading(false));
  }, []);

  const getCurrentUser = async () => {
    try {
      const data = await auth.getCurrentUser();
      //console.log(data)
      setUser(data[0]);
      setAccessToken(data[1]);
      setIdToken(data[2]);
      setIsAdmin(data[3]);
      const userService = data[0]["custom:service"];
      setService(userService);
      return { isAdmin: data[3], service: userService, idToken: data[2], accessToken: data[1] };
    } catch (err) {
      // not logged in
      console.log(err);
      setUser(null);
      setService(null);
      return false;
    }
  };

  const signIn = async (username, password) => {
    await auth.signIn(username, password);
    const userInfo = await getCurrentUser();
    return userInfo;
  };

  const signInAndOut = async (username, password) => {
    return await auth.signInAndOut(username, password);
  };

  const signOut = async () => {
    await auth.signOut();
    setUser(null);
    setAccessToken(null);
    setIdToken(null);
    setIsAdmin(false);
    setService(null);
    setAdminMode(false);
    setJwt(null);
  };

  const authValue = {
    user,
    setUser,
    accessToken,
    idToken,
    jwt,
    setJwt,
    isLoading,
    signIn,
    signOut,
    signInAndOut,
    isAdmin,
    setIsAdmin,
    service,
    setService,
    adminMode,
    setAdminMode
  };

  return (
    <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>
  );
}

export { AuthProvider, AuthContext };
